mutation UpdateFundsDafInvestmentAllocation(
  $input: UpdateFundsDafInvestmentAllocationInput!
) {
  updateFundsDafInvestmentAllocation(input: $input) {
    success
  }
}
